const money = (value) => {
  const n = Number(value);
  if (!Number.isFinite(n)) return null;
  return Math.round(n * 100) / 100;
};

export const formatPlanMoney = (value) => {
  const n = money(value);
  if (n == null) return "0";
  if (Math.abs(n - Math.round(n)) < 0.001) return String(Math.round(n));
  return n.toFixed(2);
};

/**
 * Annual card in yearly dollars. Returns null when the payload has no
 * catalog yearly price, so callers keep the per-month layout.
 *
 * The Special Promotion box is present only when `discount` carries a
 * percent. An empty discount, a past window (the API omits it), or a
 * personal upcoming-invoice override (for example a 100% coupon) hides it.
 */
export function resolveAnnualPlanCard(item) {
  const price = item?.price;
  const catalog = money(price?.plan_price);
  if (catalog == null) return null;

  const upcoming = price.upcoming_payment_amount;
  const personal = upcoming !== null && upcoming !== undefined && upcoming !== "";
  const charged = money(price.price);
  // $0 is a real comp (100% coupon). Any other upcoming total is not this
  // plan's yearly price: a scheduled downgrade previews the next tier
  // (Premium was showing Essential's $55).
  const comp = personal && charged === 0;
  const headline = comp ? 0 : catalog;

  const monthly = money(item.monthly_list_price);
  const fullYear = monthly != null ? money(monthly * 12) : null;
  const savings = fullYear != null ? money(fullYear - catalog) : 0;
  const monthsFree =
    monthly && monthly > 0 && savings > 0 ? Math.round(savings / monthly) : 0;

  const discount = item.discount || {};
  const percent = money(discount.discount_percent) || 0;
  const after = money(discount.amount_after_discount);
  const listPrice = money(discount.list_price);
  const showPromo = !personal && !comp && percent > 0 && after != null;
  const once = discount.apply_to_recurring !== true;

  const compareAt = comp
    ? catalog
    : !personal && fullYear != null && savings > 0.009
      ? fullYear
      : null;

  const struck = listPrice != null ? listPrice : catalog;

  return {
    headline: formatPlanMoney(headline),
    compareAt: compareAt == null ? null : `$${formatPlanMoney(compareAt)}/year`,
    strikeHeadline: showPromo,
    footnote: !personal && catalog === 0 ? "Free forever" : "billed annually",
    savingsLabel:
      !personal && monthsFree > 0
        ? `${monthsFree} month${monthsFree === 1 ? "" : "s"} free – you save $${formatPlanMoney(savings)}`
        : null,
    promo: showPromo
      ? {
          percentLabel: formatPlanMoney(percent),
          struck: formatPlanMoney(struck),
          price: formatPlanMoney(after),
          firstYear: once,
          detail: once
            ? `${formatPlanMoney(percent)}% off for one year only. Then $${formatPlanMoney(catalog)}/year.`
            : `${formatPlanMoney(percent)}% off.`,
        }
      : null,
  };
}

/** Yearly amount the confirm modal should print for an annual plan. */
export function annualConfirmTotal(subscription) {
  const price = subscription?.price;
  if (Number(price?.duration) !== 40) return undefined;
  const upcoming = price.upcoming_payment_amount;
  const personal = upcoming !== null && upcoming !== undefined && upcoming !== "";
  if (personal) return upcoming;
  const discount = subscription.discount;
  const percent = Number(discount?.discount_percent);
  if (percent > 0 && discount.amount_after_discount != null) {
    return discount.amount_after_discount;
  }
  return price.plan_price;
}
